import services from '../../../services'

const state = {
  info: {}
}

const actions = {
  async checkCode ({ commit }, query) {
    return await services.code_check(query)
  },
  async addCode({ commit }, query) {
    console.log('addCode')
    return await services.code_add(query)
  },
  async sendCode({ commit }, query) {
    return await services.code_send(query)
  }
}

const mutations = {

}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/phoneCode.js